/**
 * Stredná časť obrazovky – polievky a hlavné jedlá v LIST layoute.
 * Oddelená od header/ticker/allergens, aby sa dala použiť aj v iných typoch obrazoviek.
 * orientation: "landscape" | "portrait" – rozloženie (dva stĺpce vs dve sekcie).
 */
import React from "react";
import { SoupIcon, MealIcon } from "../components/SectionIcons";
import ProductCard from "./ProductCard";

export default function DailyMenuContentList({
  orientation = "landscape",
  soups = [],
  meals = [],
  locale,
  defaultLocale,
  placeholderImageSoup,
  placeholderImageMeal,
  soldOutLabel = "",
  classNamePrefix = "daily-menu-screen",
  showDescription = true,
  showPrices = true,
}) {
  const prefix = classNamePrefix || "daily-menu-screen";
  const soupsLabel = locale?.startsWith("sk") ? "Polievky" : "Soups";
  const mealsLabel = locale?.startsWith("sk") ? "Hlavné jedlá" : "Meals";
  const sectionTitleClass = `${prefix}__section-title`;
  const sectionIconClass = `${prefix}__section-icon`;

  const soupCardProps = {
    locale,
    defaultLocale,
    placeholderImage: placeholderImageSoup,
    soldOutLabel,
    classNamePrefix: prefix,
    showDescription,
    showPrices,
  };
  const mealCardProps = {
    locale,
    defaultLocale,
    placeholderImage: placeholderImageMeal,
    soldOutLabel,
    classNamePrefix: prefix,
    showDescription,
    showPrices,
  };

  const hasSoups = soups && soups.length > 0;
  const hasMeals = meals && meals.length > 0;

  if (orientation === "portrait") {
    return (
      <>
        {hasSoups && (
          <section className={`${prefix}__section`}>
            <h2 className={sectionTitleClass}>
              <SoupIcon className={sectionIconClass} size={40} />
              <span>{soupsLabel}</span>
            </h2>
            <div className={`${prefix}__items`}>
              {soups.map((item) => (
                <ProductCard
                  key={item?.id ?? item?.title}
                  item={item}
                  {...soupCardProps}
                />
              ))}
            </div>
          </section>
        )}
        {hasMeals && (
          <section className={`${prefix}__section`}>
            <h2 className={sectionTitleClass}>
              <MealIcon className={sectionIconClass} size={40} />
              <span>{mealsLabel}</span>
            </h2>
            <div className={`${prefix}__items`}>
              {meals.map((item) => (
                <ProductCard
                  key={item?.id ?? item?.title}
                  item={item}
                  {...mealCardProps}
                />
              ))}
            </div>
          </section>
        )}
      </>
    );
  }

  return (
    <>
      {hasSoups && (
        <div className={`${prefix}__column-soups`}>
          <h2 className={sectionTitleClass}>
            <SoupIcon className={sectionIconClass} size={36} />
            <span>{soupsLabel}</span>
          </h2>
          {soups.map((item) => (
            <ProductCard
              key={item?.id ?? item?.title}
              item={item}
              {...soupCardProps}
            />
          ))}
        </div>
      )}
      {hasMeals && (
        <div className={`${prefix}__column-meals`}>
          <h2 className={sectionTitleClass}>
            <MealIcon className={sectionIconClass} size={36} />
            <span>{mealsLabel}</span>
          </h2>
          {meals.map((item) => (
            <ProductCard
              key={item?.id ?? item?.title}
              item={item}
              {...mealCardProps}
            />
          ))}
        </div>
      )}
    </>
  );
}
